import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ColDef, ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LinkTarget } from '@panaya/ui/p-link';

@Component({
    selector: 'entity-linkable-renderer',
    template: `
        <a
            [class.disabled]="disable"
            [ngClass]="disable ? 'p-tpgr-disabled' : 'p-tpgr-link'"
            [target]="target"
            [attr.href]="url"
            [matTooltip]="tooltip"
            [attr.automation-id]="'linkable_renderer-app_' + appId + '-field_' + field"
            >{{ text }}</a
        >
    `,
    styleUrls: ['./linkable-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkableRendererComponent implements ICellRendererAngularComp {
    public text!: string;
    public url: string | null = null;
    public target!: LinkTarget;
    public disable = false;
    public tooltip = '';
    public appId!: number;
    public field = '';

    public refresh(params: LinkableRendererParams): boolean {
        this.extractParams(params);
        return true;
    }

    agInit(params: LinkableRendererParams): void {
        this.extractParams(params);
    }

    private extractParams(params: LinkableRendererParams): void {
        // A null/undefined result means "no link": coalesce to null so [attr.href] is
        // removed (see automation-overview's `buildUrl: () => null`). Coalescing to '' would
        // render href="", a live link to the current document that navigates on click (IN-00875).
        this.url = (params.buildText ? params.buildUrl?.(params.getValue()) : params.buildUrl?.(params.data)) ?? null;
        this.text = params.buildText
            ? params.buildText(params.getValue())
            : params.isSpecialValue
            ? params.getValue(params.data)
            : params.getValue();
        this.target = params.target || '_blank';
        // should be changed to '_top'. (after switch goes live)
        const colDef = params.colDef as ColDef;
        const inputData = colDef.cellRendererParams;
        if (inputData?.disabledFun) {
            this.disable = inputData.disabledFun(params.data);
        }
        if (inputData?.tooltipFun) {
            this.tooltip = inputData.tooltipFun(params.data);
        }
        this.field = colDef.field ?? '';
        this.appId = params.node.data?.appId;
    }
}

interface LinkableRendererParams extends ICellRendererParams {
    isSpecialValue: boolean;
    target: LinkTarget;
    buildUrl?: (data: string) => string | null;
    buildText?: (data: string) => string;
    getValue: (data?: string) => string;
    data: string;
}
